import React from 'react';

import { OrderProductsSectionProps } from '@/Order/types/orderTypes';
import {
  dividePrice,
  formatPrice,
  getCurrencySymbol,
} from '@/shared/utils/priceUtils';

const OrderProductsSection: React.FC<OrderProductsSectionProps> = ({
  orderDetails,
  currencyCode,
}) => {
  const formatCurrency = (amount: number, currency: string) => {
    const formattedCurrencyCode = currency as 'KRW' | 'USD';
    const symbol = getCurrencySymbol(formattedCurrencyCode);
    const formattedAmount = formatPrice(amount, formattedCurrencyCode);
    return `${symbol}${formattedAmount}`;
  };

  const getOptionDisplayText = (detail: any) => {
    const options = [];
    if (
      detail.productOption.optionNameKey1 &&
      detail.productOption.optionNameValue1
    ) {
      options.push(detail.productOption.optionNameValue1);
    }
    if (
      detail.productOption.optionNameKey2 &&
      detail.productOption.optionNameValue2
    ) {
      options.push(detail.productOption.optionNameValue2);
    }
    return options;
  };

  const calculateUnitPrice = (amount: number, quantity: number) => {
    return dividePrice(amount, quantity, currencyCode as 'KRW' | 'USD');
  };

  return (
    <div className="flex flex-col rounded border border-gray-200 bg-white shadow-sm">
      {orderDetails.map((detail, index) => (
        <React.Fragment key={detail.orderDetailUuid}>
          <div className="flex gap-4 p-5">
            <img
              src={
                detail.productOption.thumbnailUrlArray[0] || '/img/logo_b2b.svg'
              }
              alt="product"
              className="h-10 w-10 rounded object-contain"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/img/logo_b2b.svg';
              }}
            />
            <div className="flex-1">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h4 className="text-sm font-medium text-[#1D1D1D]">
                    {detail.productOption.productTitle}
                  </h4>
                  <div className="mt-2 flex items-center gap-2 text-xs">
                    {getOptionDisplayText(detail).map((option, optionIndex) => (
                      <span
                        // eslint-disable-next-line react/no-array-index-key
                        key={optionIndex}
                        className="rounded bg-gray-100 px-2 py-1"
                      >
                        {option}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="text-right">
                  <div className="flex items-center gap-4 text-sm text-[#646464]">
                    <span>
                      {formatCurrency(
                        calculateUnitPrice(detail.amount, detail.quantity),
                        currencyCode,
                      )}{' '}
                      × {detail.quantity}
                    </span>
                    <span className="font-medium text-[#1D1D1D]">
                      {formatCurrency(detail.amount, currencyCode)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {index < orderDetails.length - 1 && (
            <hr className="border-[#EAEAEA]" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default OrderProductsSection;
